<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">OTPS</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>OTPS</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <h3>OTPS</h3>
            <button class="btn btn-primary btn-rounded mb-2" @click="loadOtps">
              Refresh
            </button>

            <div class="table-responsive">
              <table
                id="otps_table"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>OTP No.</th>
                    <th>Mobile No.</th>
                    <th>IC No.</th>
                    <th>Type</th>
                    <th>Requested At</th>
                    <th>Used At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(otp, index) in otps" v-bind:key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ otp.otp_number }}</td>
                    <td>{{ otp.mobile_number }}</td>
                    <td>{{ otp.ic_no }}</td>
                    <td>{{ otp.type }}</td>
                    <td>{{ otp.created_at }}</td>
                    <td>{{ otp.used_at }}</td>
                    <td>
                      <button
                        v-if="otp.used_at === null"
                        @click="resendOtp(otp)"
                        class="btn btn-success btn-rounded btn-block"
                      >
                        Resend
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "otps",
  components: {},

  data() {
    return {
      user: {},
      reason: "",
      otps: []
    };
  },

  methods: {
    loadOtps() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        this.otps = [];
        this.destroyDatatable();
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.baseURL2 + "/otp", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.otps = res.data.otps;
          })
          .then(function() {
            $("#otps_table").DataTable({
              dom: "Bfrtip",
              buttons: [
                {
                  extend: "excelHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6]
                  }
                },
                {
                  extend: "pdfHtml5",
                  exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5, 6]
                  }
                }
              ]
            });
          });
      }
    },

    async resendOtp(otp) {
      let confirmation = await swal({
        icon: "warning",
        text: `Are you sure you want to send otp to ${
          otp.mobile_number
        }? Customer must be in the 'Enter OTP Form'`,
        buttons: ["Cancel", "Yes"]
      });

      if (!confirmation) {
        swal({
          icon: "info",
          text: "Cancelled"
        });

        return false;
      }
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        swal({
          icon: "warning",
          text: "No token found!"
        });

        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      axios
        .post(
          axios.baseURL2 + `/otp/resend/${otp.id}`,
          {},
          {
            headers: {
              Authorization: "Bearer " + token
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            swal({
              icon: "success",
              text: res.data.message
            });
          } else {
            swal({
              icon: "error",
              text: res.data.message
            });
          }
        });
    },

    destroyDatatable() {
      $("#otps_table")
        .DataTable()
        .destroy();
    }
  },

  beforeMount() {},

  mounted() {
    this.loadOtps();
  }
};
</script>
